import { Col } from "react-bootstrap";
import CommonButton from "./CommonButton";
import { Info } from "./svg";

const CustomPackageCard = ({
  title,
  description,
  base_price,
  monthlyCost,
  industry_tags,
  complexity,
  duration_months,
  engagement_type,
  target_platforms,
  technical_tags,
  team_roles,
  onHandelSelect,
  idealFor,
  className,
  effectiveRate,
  packagePrice,
  onHandelModal,
}) => {
  return (
    <div
      className={`pricing-card-custom pricing-card-page m-0 w-100 ${className}`}
    >
      <div className="ribbon">Custom Team Role</div>

      <h5 className="heading">{title}</h5>
      <p className="subheading">{description}</p>

      <div className="price-section">
        <span className="price-main-text">{packagePrice}</span>
        {/* <span className="original-price">${monthlyCost?.individually}</span>
        <span className="price-period">/month</span> */}
      </div>
      {monthlyCost?.Discount > 0 && (
        <div className="discount-info">
          Discount you get{" "}
          <b className="primary-color">{monthlyCost?.Discount}%</b>
        </div>
      )}
      <CommonButton
        label="Create Team & Select Package "
        className="w-100"
        onClick={onHandelModal}
      />

      <div className="section">
        <h6>Description</h6>
        <ul className="checklist p-0 m-0">
          {industry_tags?.length > 0 && (
            <li>
              Industry: <b>{industry_tags.map((i) => i?.title).join(", ")}</b>
            </li>
          )}

          {complexity && (
            <li>
              Project Complexity: <b>{complexity}</b>
            </li>
          )}

          {duration_months && (
            <li>
              Duration: <b>{duration_months} Month</b>
            </li>
          )}

          {engagement_type?.title && (
            <li>
              Engagement Type: <b>{engagement_type.title}</b>
            </li>
          )}

          {effectiveRate && (
            <li>
              Effective Rate: <b>{effectiveRate}</b> per resource
            </li>
          )}

          {target_platforms?.length > 0 && (
            <li>
              Platforms:{" "}
              <b>{target_platforms.map((i) => i?.title).join(", ")}</b>
            </li>
          )}

          {technical_tags?.length > 0 && (
            <li>
              Technical Tags:
              <div className="d-flex align-items-center flex-wrap gap-1 mt-2">
                {technical_tags.map((tag, index) => (
                  <span key={index} className="custom-pill">
                    {tag?.title}
                  </span>
                ))}
              </div>
            </li>
          )}
        </ul>
      </div>
      <hr className="line-price" />

      <div className="section">
        <div className="d-flex justify-content-between align-items-center gap-2">
          <div>
            <h6>Team you get</h6>
            <p className="muted">Suggested package based on your query..</p>
          </div>
          <CommonButton
            label="Edit"
            className="black-border py-1 px-3"
            onClick={onHandelModal}
            variant="outline"
          />
        </div>
        <CommonButton
          label="Create Team & Select Package "
          className="w-100 black-border"
          onClick={onHandelModal}
          variant="outline"
        />
        {/* {team_roles?.length > 0 && (
          <ul className="team-list">
            {team_roles?.map((item, index) => {
              return (
                <li key={index}>
                  <div>
                    <b style={{ color: "#ff5500" }}>{item?.quantity}</b>{" "}
                    {item?.team_roles?.seniority} {item?.team_roles?.role_name}{" "}
                  </div>
                  <span>
                    <b>{item?.team_roles?.experience_levels}</b>
                  </span>
                </li>
              );
            })}
          </ul>
        )} */}
      </div>

      {idealFor?.length > 0 && (
        <>
          <hr className="line-price" />
          <div className="section">
            <h6>Ideal for</h6>
            <ul className="dot-list">
              {idealFor?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </>
      )}
      {/* <hr className="line-price" />
      <div className="section breakdown">
        <p>
          When Offer individually{" "}
          <span style={{ opacity: "0.5" }}>${monthlyCost?.individually}</span>
        </p>
        <p>
          You save (No hidden charge) <span>${monthlyCost?.youSave}</span>
        </p>
        {monthlyCost?.Discount > 0 && (
          <p>
            <span>
              Summer Discount <Info />
            </span>
            <span style={{ color: "#ff9900" }}>{monthlyCost?.Discount}%</span>
          </p>
        )}
        {monthlyCost?.packagePrice && (
          <p>
            Package rate{" "}
            <span className="bold">${monthlyCost?.packagePrice}</span>
          </p>
        )}
        <p style={{ color: "red" }}>
          Quote Valid till ⏱️
          <span className="date">
            1<sup>st</sup> July 2025
          </span>
        </p>
      </div> */}

      {/* <CommonButton
        label="Select Package"
        className="w-100"
        onClick={onHandelSelect}
      /> */}
    </div>
  );
};

export default CustomPackageCard;
